import { type NonEmptyArray } from '@/packages/JsonQuery';
import { EEntranceType } from '@/packages/api-models/common/json_query';

import { EInternalEntranceType, type IEntranceTypeOption } from './types';

export const ENTRANCE_TYPE_OPTIONS: IEntranceTypeOption[] = [
  { label: 'Неважно', value: null },
  { label: 'С улицы', value: EInternalEntranceType.Street },
  { label: 'Со двора', value: EInternalEntranceType.Courtyard },
];

export const SEPARATE_ENTRANCE_TYPES: NonEmptyArray<EEntranceType> = [
  EEntranceType.SeparateStreet,
  EEntranceType.SeparateCourtyard,
];
